import form_module_default from "./form.module.js";
import classNames from "classnames";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
import { Field } from "@radix-ui/react-form";
//#region src/components/Form/Field.tsx
/**
* Thin wrapper around Radix UI Field component
* https://www.radix-ui.com/docs/primitives/components/form#field
*/
var Field$1 = forwardRef(function Field$2({ children, ...props }, ref) {
	const classes = classNames(form_module_default.field, props.className);
	return /* @__PURE__ */ jsx(Field, {
		ref,
		...props,
		className: classes,
		children
	});
});
//#endregion
export { Field$1 as Field };

//# sourceMappingURL=Field.js.map